module.exports = __webpack_public_path__ + "static/img/1-2.245d4b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Economics/1-2.png
// module id = agus
// module chunks = 0